import { ApiService } from "./api.service";
import type {
  TCategoryValueCreateInput,
  TCategoryValueUpdateInput,
  TWorkspaceCategoryField,
  TWorkspaceCategoryValue,
} from "@/types/standard-fields";

export class WorkspaceCategoriesService extends ApiService {
  async listFields(slug: string): Promise<TWorkspaceCategoryField[]> {
    return this.get(`/api/workspaces/${slug}/category-fields/`);
  }

  async listValues(slug: string, categoryId: string): Promise<TWorkspaceCategoryValue[]> {
    return this.get(`/api/workspaces/${slug}/category-fields/${categoryId}/values/`);
  }

  async createValue(
    slug: string,
    categoryId: string,
    data: TCategoryValueCreateInput,
  ): Promise<TWorkspaceCategoryValue> {
    return this.post(`/api/workspaces/${slug}/category-fields/${categoryId}/values/`, data);
  }

  async updateValue(
    slug: string,
    categoryId: string,
    valueId: string,
    data: TCategoryValueUpdateInput,
  ): Promise<TWorkspaceCategoryValue> {
    return this.patch(
      `/api/workspaces/${slug}/category-fields/${categoryId}/values/${valueId}/`,
      data,
    );
  }

  /**
   * Persist a new value order. Sends the full ordered id list to the collection
   * endpoint (house pattern); the server re-numbers `order` and returns the
   * reordered list.
   */
  async reorderValues(
    slug: string,
    categoryId: string,
    orderedIds: string[],
  ): Promise<TWorkspaceCategoryValue[]> {
    return this.patch(`/api/workspaces/${slug}/category-fields/${categoryId}/values/`, {
      order: orderedIds,
    });
  }

  /**
   * Hard-delete a category value. Resolves on `204 No Content`; rejects with the
   * Axios error on `409 Conflict` (delete blocked — the caller reads
   * `error.response.data` as a `TCategoryValueDeleteBlocked`). Only offered on
   * inactive, non-default rows in the UI (the BE enforces both too).
   */
  async deleteValue(slug: string, categoryId: string, valueId: string): Promise<void> {
    await this.delete(`/api/workspaces/${slug}/category-fields/${categoryId}/values/${valueId}/`);
  }
}
